import React, { useState, useEffect, useCallback } from 'react';
import { Select, Spin } from 'antd';
import api from '../utils/axios';

const { Option } = Select;

const PositionSelect = ({ 
  value, 
  onChange, 
  departmentId, // 部门ID，用于筛选职位
  placeholder = "请选择职位", 
  allowClear = true,
  style = { width: '100%' },
  ...props 
}) => {
  const [positions, setPositions] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchAllPositions = useCallback(async () => {
    setLoading(true);
    try {
      console.log('🔍 获取所有职位列表...');
      const response = await api.get('/positions');
      console.log('✅ 获取职位列表成功:', response.data);
      if (response.data.success) {
        setPositions(response.data.data || []);
      } else {
        setPositions([]);
      }
    } catch (error) {
      console.error('❌ 获取职位列表失败:', error);
      setPositions([]);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchPositionsByDepartment = useCallback(async (deptId) => {
    setLoading(true);
    try {
      console.log('🔍 根据部门获取职位列表, departmentId:', deptId);
      const response = await api.get(`/positions?department_id=${deptId}`);
      console.log('✅ 根据部门获取职位列表成功:', response.data);
      if (response.data.success) {
        setPositions(response.data.data || []);
      } else {
        setPositions([]);
      }
    } catch (error) {
      console.error('❌ 根据部门获取职位列表失败:', error);
      // 如果按部门查询失败，回退到获取所有职位
      await fetchAllPositions();
    } finally {
      setLoading(false);
    }
  }, [fetchAllPositions]);

  useEffect(() => {
    if (departmentId) {
      fetchPositionsByDepartment(departmentId);
    } else {
      fetchAllPositions();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [departmentId]);

  // 当部门改变时，清空职位选择
  useEffect(() => {
    if (departmentId && value) {
      const positionExists = positions.find(p => p.id === value);
      if (!positionExists) {
        onChange?.(undefined);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [departmentId, positions, value]);

  console.log('🎯 PositionSelect 渲染状态:', { 
    positions: positions.length, 
    loading, 
    departmentId, 
    value,
    placeholder 
  });

  return (
    <Select
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      allowClear={allowClear}
      style={style}
      loading={loading}
      notFoundContent={loading ? <Spin size="small" /> : null}
      showSearch
      optionFilterProp="children"
      getPopupContainer={(triggerNode) => triggerNode.parentNode}
      {...props}
    >
      {positions.map(position => (
        <Option key={position.id} value={position.id}>
          {position.name} ({position.code})
        </Option>
      ))}
    </Select>
  );
};

export default PositionSelect; 